import React from 'react';
import {injectIntl} from "react-intl";

function PostalAutosuggestField() {
  return '';
}

export default injectIntl(PostalAutosuggestField);
